<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self" @reload="$reloadHandle"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height">
					<vxe-grid ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">新增</vxe-button>
								</div>
								<div class="fr">
									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
									<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="searchEvent">
								<vxe-form-item title="用户角色:" field="name">
									<template v-slot>
										<el-input v-model="formData.name" size="small" clearable />
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
export default {
	name: 'role:list',
	components: {
		editView
	},
	created() {},
	mounted() {
		this.initTableList();
	},
	data() {
		return {
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			formData: {}
		};
	},
	methods: {
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');
		},
		resetEvent() {
			this.formData = {};
			this.$refs['table-m1'].commitProxy('reload');
		},
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? '' : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_role_list-m1',
				path: USER_PREFIX + '/role/listCurrentPage',
				param: () => {
					return this.formData;
				},
				columns: [
					{
						type: 'checkbox',
						fixed: 'left',
						width: 48,
						resizable: false
					},
					{
						title: '用户角色',
						field: 'name',
						width: 150,
						sortable: true,
						fixed: 'left'
					},
					{
						title: '角色描述',
						field: 'description',
						width: 150
					},
					{ title: '所属组织', field: 'companyName', width: 150 },
					{
						field: 'createDate',
						title: '创建时间',
						width: 150
					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<a
										href="javascript:void(0);"
										class="a-link"
										onclick={() => {
											this.openEditDialog(row.id);
										}}
									>
										<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-edit" />
										</el-tooltip>
									</a>
								];
							}
						}
					}
				]
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				this.vxeOption = opts;
			});
		}
	}
};
</script>

<style>
.sortable-column-demo .vxe-header--row .vxe-header--column.sortable-ghost,
.sortable-column-demo .vxe-header--row .vxe-header--column.sortable-chosen {
	background-color: #dfecfb;
}

.sortable-column-demo .vxe-header--row .vxe-header--column.col--fixed {
	cursor: no-drop;
}
</style>
